import { useMemo } from "react";
import type { BrandId, BrandSource } from "./brand.ts";
import { useResolvedBrand } from "./brandSync.tsx";
import { assistantForBrand, type AssistantProfile } from "./assistantProfile.ts";

export interface Brand {
  id: BrandId;
  source: BrandSource;
  title: string;
  assistant: AssistantProfile;
}

/**
 * The brand the signed-in user is in: product name, assistant and which rule
 * chose it. Read it here instead of combining the theme pack, the host title and
 * the endpoint at the call site, so every surface names the same product.
 */
export function useBrand(): Brand {
  const resolved = useResolvedBrand();
  return useMemo(() => ({ ...resolved, assistant: assistantForBrand(resolved.id) }), [resolved]);
}
